(ns fx.sente
  (:require [comms.sente :as sente-comms]
            [re-frame.core :as rf]))

;; -- helpers ---------------------------------------------------------------

(defn- ->seq [x]
  (if (sequential? x) x [x]))

(defn- dispatch! [target & payload]
  (when target
    (cond
      (vector? target)
      (rf/dispatch (into (vec target) payload))

      (fn? target)
      (apply target payload)

      :else
      (js/console.error "fx.sente :: invalid dispatch target (must be event vector or fn):" (type target) target))))

(defn- classify-reply
  "Returns {:ok? true :data ...} or {:ok? false :error ...}.

   A transport failure is turned into a sentence here rather than passed on
   as the raw Sente keyword: every caller of this puts `:error` in front of
   someone, and `:chsk/timeout` means nothing to them."
  [reply]
  (cond
    (sente-comms/transport-failure? reply)
    {:ok? false :error (sente-comms/transport-failure-message reply)}

    (and (map? reply)
         (#{:error :err :failed} (:status reply))) {:ok? false :error reply}

    :else {:ok? true :data reply}))

;; -- effect: ::sente/send ---------------------------------------------------
;; Usage: (rf/dispatch [::sente/send
;;          {:ev [:zap-vault/load-config]
;;           :on-request [:loading/show]
;;           :on-ok [:app.zap-vault.event/load-app-config-response]
;;           :on-error [:notify/error]
;;           :timeout-ms 8000
;;           :transform-reply (fn [r] (get r :data))}])

(rf/reg-fx
 ::send
 (fn send-effect [reqs]
   (doseq [{:keys [id data on-request on-ok on-error timeout-ms transform-reply]
            :or   {timeout-ms 10000}}
           (->seq reqs)]

     (assert (and on-ok on-error) "Must have on-ok and on-error handlers")
     (doseq [[k v] {:on-request on-request :on-ok on-ok :on-error on-error}]
       (when v
         (assert (or (fn? v)
                     (vector? v))
                 (str "fx ::sente/send " (name k) " must be an event vector or a fn"))))

     (let [ev [id data]]
       ;; fire 'request started'
       (when on-request
         (dispatch! on-request {:ev ev}))

       ;; race callback vs timeout so we can guarantee exactly one terminal dispatch
       (let [done?* (atom false)
             tid (js/setTimeout
                  (fn []
                    (when (compare-and-set! done?* false true)
                      (dispatch! on-error {:error :timeout})))
                  timeout-ms)
             cb (fn [reply]
                  (when (compare-and-set! done?* false true)
                    (js/clearTimeout tid)
                    (js/console.log "HERE : " reply)
                    (let [{:keys [ok? data error]}
                          (-> reply
                              (cond-> transform-reply (transform-reply))
                              (classify-reply))]
                      (js/console.log "HEre 2 : " ok? " > " data " << " on-ok)
                      (if ok?
                        (dispatch! on-ok data)
                        (dispatch! on-error error)))))]
         ;; uses your comms.sente/send! (queues if closed)
         (sente-comms/rpc-when-open! ev cb))))))
